<form nz-form [formGroup]="form" autocomplete="off">
    <nz-form-control nz-col nzSpan="24">
        <div class="title-14">
            {{'global.login.label.register_password' | translate }} :

            <i nz-tooltip [nzTooltipTitle]="tooltipTemplate" [nzTooltipColor]="'white'"
                 nz-icon nzType="info-circle"
                style="font-size: 16px; color: #1890ff; cursor: pointer;">
            </i>
        </div>
        <nz-input-group [nzSuffix]="suffixPasswordTemplate" class="password">
            <input nz-input formControlName="password" [type]="passwordVisible ? 'text' : 'password'"
                placeholder="{{'global.login.label.register_password' | translate }}" [ngClass]="{
                               'input-error': form?.controls['password'].invalid && (form?.controls['password'].touched || form?.controls['password'].dirty)
                           }" />
        </nz-input-group>
        <br>
        <app-validation-errors
            *ngIf="(form?.controls['password'].touched || form?.controls['password'].dirty) && form?.controls['password'].invalid"
            [errors]="form?.get('password').errors" label="signUpPassword">
        </app-validation-errors>
        </nz-form-control>
        
        <ng-template #suffixPasswordTemplate>
            <i nz-icon [nzType]="passwordVisible ? 'eye':'eye-invisible' " (click)="passwordVisible = !passwordVisible"></i>
        </ng-template>
        
        
        
        <nz-form-control nz-col nzSpan="24">
            <div class="title-14">
                {{'global.login.label.confirm_password' | translate }} :
            </div>
            <nz-input-group [nzSuffix]="suffixConfirmPasswordTemplate" class="password">
                <input nz-input formControlName="confirmPassword" [type]="confirmPasswordVisible ? 'text' : 'password'"
                    placeholder="{{'global.login.placeholder.confirm_password' | translate }}" [ngClass]="{
                                                    'input-error': form?.controls['confirmPassword'].invalid && (form?.controls['confirmPassword'].touched || form?.controls['confirmPassword'].dirty)
                                                }" />
            </nz-input-group>
            <br>
            <app-validation-errors
                *ngIf="(form?.controls['confirmPassword'].touched || form?.controls['confirmPassword'].dirty) && form?.controls['confirmPassword'].invalid"
                [errors]="form?.get('confirmPassword').errors">
            </app-validation-errors>
        
            <ng-template #suffixConfirmPasswordTemplate>
                <i nz-icon [nzType]="confirmPasswordVisible ? 'eye':'eye-invisible'"
                    (click)="confirmPasswordVisible = !confirmPasswordVisible"></i>
            </ng-template>
        </nz-form-control>


    <ng-template #tooltipTemplate>
        <ul style="list-style-type: disc; padding-left: 20px;">
            <li>{{"global.errors.Sign_up_error1" | translate}}</li>
            <li>{{"global.errors.Sign_up_error2" | translate}}</li>
            <li>{{"global.errors.Sign_up_error3" | translate}}</li>
            <li> {{"global.errors.Sign_up_error4" | translate}}</li>
            <li>{{"global.errors.Sign_up_error5" | translate}}</li>
            <li>{{"global.errors.Sign_up_error6" | translate}}</li>
        </ul>
    </ng-template>
</form>